export default __webpack_public_path__ + "static/av-piece-2-4ae30991b3f84508f526f09774b368e8.jpg";